import React, { FC, useContext } from "react"
import { useFormContext } from "react-hook-form"
import { H2 } from "@carrotfertility/carotene"
import { useEnrollmentFlowModal } from "../EnrollmentModal"
import { getHeap } from "../../../utils/heap"
import { useStateMachine } from "../../context/stateMachine/StateMachineContext"
import { SendMessageFormContext } from "../../talk-to-carrot/send-message/SendMessage"
import { Spacer } from "../../views/atoms/Atoms"
import { LegacyMessageTextArea, SendMessageEmailInput } from "../../talk-to-carrot/send-message/SendMessageForm"
import { ButtonPrimary } from "../../views/atoms/buttons/ButtonPrimary"
import { BenefitEnrollmentFlowModalBackButton } from "../shared"
import { Body } from "components/views/atoms/Bodies"
import { Steps } from "../workflow/steps"
import { FormattedMessage, useIntl } from "react-intl"
import { MessageSent } from "./MessageSent"

interface TalkToCarrotStepProps {
  onExit: () => void
}
const ViewName = Steps.TALK_TO_CARROT

const TalkToCarrotStep: FC<TalkToCarrotStepProps> = () => {
  const { sent, onSubmit } = useContext(SendMessageFormContext)
  const {
    formState: { isValid, isSubmitting }
  } = useFormContext()
  const { onExit } = useEnrollmentFlowModal()
  const intl = useIntl()

  useStateMachine(ViewName, null)

  const sendSupportRequest = () => {
    onSubmit()
    getHeap().track("EnrollmentFlowSupportRequest", { EventName: "I'm not sure" })
  }

  return (
    <>
      {sent ? (
        <MessageSent close={true} onClick={() => onExit()} />
      ) : (
        <>
          <BenefitEnrollmentFlowModalBackButton />
          <Spacer height={1} />
          <H2 variant="primary">
            <FormattedMessage defaultMessage="It looks like you weren't sure how to answer the last question. That's okay." />
          </H2>
          <Spacer height={1} />
          <Body color="black-80">
            <FormattedMessage defaultMessage="But we still need this information in order to reimburse you. Tell us what you weren’t sure about about or what we can help clarify. The more detail you can provide, the better." />
          </Body>
          <Spacer height={2.5} />
          {/* TODO: When this is updated for a11y remove the isEnrollmentFlow prop and notify Hipposlide that this work is complete. */}
          <SendMessageEmailInput showUpdateContactInfo={false} isEnrollmentFlow={true} />
          <Spacer height={2} />
          {/* TODO: When this is updated for a11y replace <LegacyMessageTextArea> with <MessageTextArea> and notify Hipposlide that this work is complete. */}
          <LegacyMessageTextArea showPlaceholderText={false} rows="3" />
          <div className="flex flex-row justify-end">
            <ButtonPrimary
              onClick={sendSupportRequest}
              enabled={isValid && !isSubmitting}
              disabledBackgroundColor="black-10"
            >
              {intl.formatMessage({ defaultMessage: "Send" })}
            </ButtonPrimary>
          </div>
        </>
      )}
    </>
  )
}

export { TalkToCarrotStep }
